import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { router } from "routes";
import { reactQueryConfig } from "services/api/apiHelper";
import { Toaster } from "react-hot-toast";
import { TenantProvider } from "context/TenantContext";

const queryClient = new QueryClient(reactQueryConfig);

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <TenantProvider>
      <RouterProvider router={router} />
    </TenantProvider>
    <Toaster />
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
